import { makeAutoObservable } from "mobx"
import Store from ".."
import LoyaltyStoreX from "../loyalty"
import { getMyWallets, updateAccount } from "../../api/users"

import 'dayjs/locale/ru'
import dayjs from 'dayjs'
import moment from "moment"
import { message } from "antd"
import { isNullOrUndefined } from "../../utils"

export default class UserApiStore {

  mainStore: Store
  loyaltyStore: LoyaltyStoreX

  favorites: any[] = []

  userName: string = ""
  userSurname: string = ""
  userPhone: string = ""
  userEmail: string = ""

  optionsGender: any[] = [
    { label: 'Не выбран', value: 'none' }, 
    { label: 'Мужской', value: 'men' },
    { label: 'Женский', value: 'women' }
  ]

  isEmailSubscribed: boolean = false
  isPhoneSubscribed: boolean = false
  isLogoutVisible: boolean = false

  selCompany: string = "topgun"
  genderSelected: string = "none"

  selectedDate: dayjs.Dayjs = dayjs(moment().add("-18", "years").format("YYYY-MM-DD"))
  selectedDateStr: string = moment().add("-18", "years").format("YYYY-MM-DD")
  birthdateDisplay: string = ""

  constructor(main: Store, loyalty: LoyaltyStoreX) {
    makeAutoObservable(this)

    this.mainStore = main
    this.loyaltyStore = loyalty
  }

  setSelectedDate = (val: dayjs.Dayjs) => this.selectedDate = val
  setSelectedDateStr = (val: string) => this.selectedDateStr = val
  setBirthdateDisplay = (val: string) => this.birthdateDisplay = val
  setGenderSelected = (val: string) => this.genderSelected = val
  setOptionsGender = (val: any[]) => this.optionsGender = val

  setUserName = (val: string) => this.userName = val
  setUserSurname = (val: string) => this.userSurname = val
  setUserPhone = (val: string) => this.userPhone = val
  setUserEmail = (val: string) => this.userEmail = val

  setSelCompany = (val: any) => this.selCompany = val
  
  setIsEmailSubscribed = (val: boolean) => this.isEmailSubscribed = val
  setIsPhoneSubscribed = (val: boolean) => this.isPhoneSubscribed = val
  setIsLogoutVisible = (val: boolean) => this.isLogoutVisible = val

  setFavorites = (val: any) => this.favorites 

  public async fetchAccountData() {
    this.setUserName(this.mainStore.userData.name)
    this.setUserSurname(this.mainStore.userData.surname)
    this.setUserPhone(this.mainStore.userData.phone)
    this.setUserEmail(this.mainStore.userData.email)
    this.setGenderSelected(this.mainStore.userData.gender === 0 ? "none" : (this.mainStore.userData.gender === 1 ? "men" : "women"))
    
    let dts = this.mainStore.userData.birthdate
    if (dts.includes("/")) {
      let dtx = dts.split("/").reverse()
      dts = `${dtx[0]}-${dtx[1]}-${dtx[2]}`
    }
    
    console.log(dts)
    
    const parsedDate = dayjs(dts)
    this.setSelectedDate(parsedDate)
    this.setSelectedDateStr(this.mainStore.userData.birthdate)
    this.setBirthdateDisplay(parsedDate.format("DD") + "." + parsedDate.format("MM") + "." + parsedDate.format("YYYY"))
    this.setIsEmailSubscribed(this.mainStore.userData.email_subscribed)
    this.setIsPhoneSubscribed(this.mainStore.userData.phone_subscribed)
  }

  public async updateAccount() {
    let props: any = {}
    
    if (this.userName !== this.mainStore.userData.name) {
      props.name = this.userName
    }
    if (this.userSurname !== this.mainStore.userData.surname) {
      props.surname = this.userSurname
    }
    if (this.userPhone !== this.mainStore.userData.phone) {
      props.phone = this.userPhone
    }
    if (this.userEmail !== this.mainStore.userData.email) {
      props.email = this.userEmail
    }
    if (this.genderSelected !== this.mainStore.userData.gender) {
      props.gender = this.genderSelected === "none" ? 0 : (this.genderSelected === "men" ? 1 : 2)
    }
    if (this.selectedDateStr !== this.mainStore.userData.birthdate) {
      props.birthdate = this.selectedDateStr
    }
    if (this.isEmailSubscribed !== this.mainStore.userData.email_subscribed) {
      props.email_subscribed = this.isEmailSubscribed
    }
    if (this.isPhoneSubscribed !== this.mainStore.userData.phone_subscribed) {
      props.phone_subscribed = this.isPhoneSubscribed
    }
    
    const res = await updateAccount(this.mainStore.userData.id, props)
    
    this.mainStore.setUserData({...this.mainStore.userData, ...props}, null)
    
    if (res.state === 1) {
      message.success("Данные успешно обновлены!")
    } else {
      message.error(res.data.message)
    }
  }

  public async updateUserAvatar() {
    const res = await updateAccount(this.mainStore.userData.id, {
      avatar: this.mainStore.userData.avatar
    })

    if (res.state === 1) {
      message.success("Аватар успешно обновлен!")
    } else {
      message.error(res.data.message)
    }
  }

  public async fetchWallets() {
    const res = await getMyWallets()
    const wallets: any[] = res.wallets ?? []
    this.loyaltyStore.setWallets(wallets)

    const activeWallet = wallets.find(v => v.status === 1)
    if (activeWallet !== undefined) {
      this.loyaltyStore.setActiveWallet(activeWallet)
    }
  }


  public isNullPriced() {
    if (!isNullOrUndefined(this.mainStore.subscribeData) && this.mainStore.subscribeData.sub_name === "sub1") {
      return true
    }

    return false
  }

  public isHasVisitSale() {
    if (this.mainStore.userData.has_visits_month && isNullOrUndefined(this.mainStore.subscribeData)) {
      return true
    }

    return false
  }

}